import React, { useContext, useEffect } from "react";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import PlusIcon from "@components/Icons/PlusIcon";
import Button from "@components/Ui/Button";
import Drawer from "@components/V3/Drawer";
import Venues from "@components/V3/VenueFinder/venues";
import "./style.scss";

const VenueFinder = ({ selectedVenue, handleVenueClick }) => {
    const { cinemas, fetchSubscriberCinemas } = useContext(ApplicationContext);
    const { drawerState, openDrawer, closeDrawer } = useContext(AuthContext);
    
    useEffect(() => {
        if (cinemas.length === 0) {
            fetchSubscriberCinemas();
        }
    }, [cinemas.length, fetchSubscriberCinemas]);

    const venueList = Array.from(new Set(cinemas.map((venue) => ({
        label: venue.name,
        value: venue.name,
    }))));

    const selectedVenueOption = venueList.find(
        (item) => item.value.toLowerCase() === selectedVenue?.toLowerCase(),
    )?.value;

    return (
        <div className="venues-finder">
            {selectedVenue ? (
                <Button additionalClasses="venue-finder__button" onClick={() => openDrawer("venuesDrawer")}>
                    {selectedVenueOption} <PlusIcon className="venue-finder__icon" />
                </Button>
            ) : (
                <Button additionalClasses="venue-finder__button" onClick={() => openDrawer("venuesDrawer")}>
                    Find a cinema <PlusIcon className="venue-finder__icon" />
                </Button>
            )}
            <Drawer isOpen={drawerState.venuesDrawer} onClose={() => closeDrawer("venuesDrawer")} closeButtonAlignment="right">
                <Venues 
                    handleVenueClick={handleVenueClick}
                    selectedVenue={selectedVenueOption}
                    venueList={venueList}
                />
                <Button additionalClasses="button button__primary" onClick={() => closeDrawer("venuesDrawer")}>
                    Save and browse
                </Button>
            </Drawer>
        </div>
    );
};

export default VenueFinder;
